import './CustomFormPageTitleAndDescription.scss';
import { Flex } from '@chakra-ui/react';
import React from 'react';

import CustomStepperCTA from '@/common/storyblok/CustomStepper/CustomStepperCTA/CustomStepperCTA';
import CustomStepperStandalone from '@/common/storyblok/CustomStepper/CustomStepperStandalone/CustomStepperStandalone';

interface CustomFormPageTitleAndDescriptionProps {
  title?: string;
  description?: string;
  isStandaloneForm?: boolean;
  steps: { title: string }[];
  activeStep: number;
  goBackToSelectedStep: (step: number) => void;
}

const CustomFormPageTitleAndDescription = ({
  title,
  description,
  isStandaloneForm,
  steps,
  activeStep,
  goBackToSelectedStep,
}: CustomFormPageTitleAndDescriptionProps) => {
  return (
    <Flex className="custom-form-page-title-and-description-container">
      <Flex className={'custom-form-page-title-section-container'}>
        {!isStandaloneForm && steps.length > 1 && (
          <CustomStepperCTA steps={steps} activeStep={activeStep} />
        )}

        {title && <h2 className={'custom-form-page-title'}>{title}</h2>}
      </Flex>

      {isStandaloneForm && steps.length > 1 && (
        <CustomStepperStandalone
          steps={steps}
          activeStep={activeStep}
          goBackToSelectedStep={goBackToSelectedStep}
        />
      )}

      {description && (
        <span className={`custom-form-page-description`}>{description}</span>
      )}
    </Flex>
  );
};
export default CustomFormPageTitleAndDescription;
